import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

export const batchPaymentService = {
    getWebNotRun,
    processCards,
    getDepositSlip,
    uploadDepositSlipEntry
};
const baseUrl = `/api/batch-payments`;

function getWebNotRun(): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/web-not-run`,
        customErrorMessage: `Failed to get web not run jobs`,
    };
    return handleServiceRequest.get(getObject);
}
function processCards(jobIdsToProcess: number[] = []): Promise<any>  {
    const postObj = {
        url: `${baseUrl}/web-not-run/process`,
        postBody: {
            processAllEligibleJobs: jobIdsToProcess.length === 0,
            processJobIds: jobIdsToProcess
        },
        customErrorMessage: `Failed to process cards`,
    };
    return handleServiceRequest.post(postObj);
}

function getDepositSlip(depositSlipNumber: string) {
    const getObject = {
        url: `${baseUrl}/deposit-slips/${depositSlipNumber}`,
        customErrorMessage: `Failed to get deposit slip`,
    };
    return handleServiceRequest.get(getObject);
}

function uploadDepositSlipEntry(depositSlipNumber: string, customerNumber: string, PlayErrorSound: (error: any) => void) {
    const postObj = {
        url: `${baseUrl}/deposit-slips`,
        postBody: {
            depositSlipNumber,
            customerNumber
        },
        customHandleError: PlayErrorSound,
        customErrorMessage: `Failed to upload deposit slip`,
    };
    return handleServiceRequest.post(postObj);
}